import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface NoteGroup {
  id: string
  userId: string
  name: string
  noteIds: string[]
  source: 'editor' | 'rightEditor'
  createdAt: string
  updatedAt: string
}

interface NoteGroupState {
  groups: NoteGroup[]
  isLoading: boolean
}

const initialState: NoteGroupState = {
  groups: [],
  isLoading: false,
}

const noteGroupSlice = createSlice({
  name: 'noteGroups',
  initialState,
  reducers: {
    setNoteGroups(state, action: PayloadAction<NoteGroup[]>) {
      state.groups = action.payload
    },
    setNoteGroupsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload
    },
    addNoteGroup(state, action: PayloadAction<NoteGroup>) {
      if (!state.groups.find(g => g.id === action.payload.id)) {
        state.groups.unshift(action.payload)
      }
    },
    removeNoteGroup(state, action: PayloadAction<string>) {
      state.groups = state.groups.filter(g => g.id !== action.payload)
    },
  },
})

export const { setNoteGroups, setNoteGroupsLoading, addNoteGroup, removeNoteGroup } = noteGroupSlice.actions
export default noteGroupSlice.reducer